import { render, staticRenderFns } from "./ActionContactDone.vue?vue&type=template&id=0fda49b0&"
import script from "./ActionContactDone.vue?vue&type=script&lang=js&"
export * from "./ActionContactDone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports